import { FormInstance } from "src/assets/imports/antdComponents";
import { ModuleType } from "src/components/SubHeader/interface";

type FileTypeString = "Transcript" | "Report" | "Discussion Guide";
export type UserAccessTypeString = "Read Access" | "Full Access" | "No Access";
type studyTypeString = "Market Research" | "Reports" | "Notes";
type statusLogString = "success" | "failed" | "queued" | "processing" | "upload_failed" | "uploading" | "warn";

export enum userAccessType {
	view = "Read Access",
	edit = "Full Access",
	none = "No Access",
}

export enum roleAccessType {
	Admin = "Admin",
	Analyst = "Analyst",
	Developer = "Developer",
	Support = "Support",
	Observer = "Monitoring_Observer",
	Superadmin = "superadmin"
}

export enum storyType {
	type1 = "Market Research",
	type2 = "Reports",
	type3 = "Notes, Social",
	type4 = "Quantitative Market Research",
	type5 = "Simulation Study",
	type6 = "Web-Boards",
	type7 = "PXB",
}

export enum notesType {
	type1 = "Notes",
	type2 = "Questions & Answers",
	type3 = "Web-Board/Social",
	type4 = "Custom",
}

export interface INotesTemplate {
	name: string;
	isDateTime: boolean;
	isMandatory: boolean;
	multipleAllowed: boolean;
}

export enum confirmationTypes {
	type1 = "closeIcon",
	type2 = "switch",
	type3 = "sideBar",
	type4 = "form",
	type5 = "reports",
}

export enum confirmationStatusType {
	success = "success",
	failure = "failure",
	warning = "warning",
}

export enum fileStatus {
	uploading = "uploading",
	uploaded = "uploaded",
	queued = "queued",
	processing = "processing",
	preprocessing_failed = "processing_failed",
	success = "success",
	warn = "warn",
	failed = "failed",
	upload_failed = "upload_failed",
	validation_failed = "validation_failed",
	reupload_failed = "reupload_failed",
	partial_processed = "partial_processed",
}

export enum fileTypes {
	discussion_guide = "Discussion Guide",
	transcript = "Transcript",
	report = "Report",
	metadata = "Metadata",
	all = "All",
	allInsights = "All Insights",
	insightsQuestion = "Insights Question",
	addUsers = "Add Users",
	notes = "Notes",
	logs = "EventLogs",
	errorlogs = "ErrorLogs",
	addTaxonomy = "Add Taxonomy",
	survey = "Survey",
	rawData = "Raw Data",
	adm = "Adm",
	analysisConfig = "Analysis Config",
	chartConfig = "Chart Config",
	iteration = "Iteration",
	ppt_template = "Deck Template",
	segment = "Segment",
	Insights = "Insights",
	helix = "helix",
	Mapping = "Mapping",
	QUantMapping = "Quant Mapping",
}

export enum downloadFormats {
	discussion_guide = "docx",
	transcript = "docx",
	report = "docx",
	metadata = "xlsx",
	all = "zip",
	note = "xlsx",
}

export enum accessErrorTypes {
	NO_ROLES = "NO_ROLES", //no profile page
	NO_PROFILES = "NO_PROFILES", //no profile page
	ADMIN_ROLE_NO_PROFILE = "ADMIN_ROLE_NO_PROFILE", //Move to admin center
	PROFILE_REVOKED = "PROFILE_REVOKED", //modal and button disable
	ADMIN_REVOKED = "ADMIN_REVOKED", //modal and admin button disable
	COLLABORATOR_REMOVED_VIEW = "COLLABORATOR_REMOVED_VIEW", //modal and manage studies button disable
	COLLABORATOR_REMOVED_EDIT = "COLLABORATOR_REMOVED_EDIT",
	ACCOUNT_DISABLED = "ACCOUNT_DISABLED", //modal and on refresh no profile page
	ACCESS_EXPIRED = "ACCESS_EXPIRED", //dedicated splash; no auto-retry, no token refresh
	APP_ACCESS_EXPIRED = "APP_ACCESS_EXPIRED", //app-license hard cutoff: full-page splash, no logout/token refresh, no retry
	INSUFFICIENT_PERMISSIONS = "INSUFFICIENT_PERMISSIONS", //modal
	FEATURE_DISABLED = "FEATURE_DISABLED", //modal
}

export enum ErrorTypes {
	EMAIL = "email",
	PROFILE = "profile",
	NONE = null,
	IDM = "IDM",
	DATABASE = "Database",
	UNKNOWN = "Unknown",
	LANGUAGE = "LANGUAGE",
	HTTP = "http",
	ROLE = "role",
	VALIDATION = "validation",
	WARNING = "warning",
}

export enum StudyPageViewType {
	Grid = "grid",
	List = "list",
	Table = "table",
}

export enum ReportsPageViewType {
	Grid = "grid",
	List = "list",
	Table = "table",
}

export enum StudyPageTabType {
	Recent = "Recent",
	Starred = "Starred",
	All = "All",
}

export enum StudyPageTabTypeRevamp {
	All = "All",
	Starred = "Starred",
	Collections = "Collections",
	Studies = "Studies",
}

export enum ReportsHomePageTabType {
	Recent = "Recent",
	Starred = "Starred",
	All = "All",
}

export enum PageNavigationType {
	"Studies" = "/studies",
	"Storyboard" = "/storyboard",
	"My Feed" = "/my-feed",
	"Ask Kural" = "/ask-kural",
	"Manage Studies" = "/manage-studies",
	"Add Study" = "/add-study",
	"Insights" = "/insights",
	"Admin Center" = "/admin-center",
	"Feature Management" = "/feature-management",
	"Events" = "/event-logs",
	"User Observability" = "/user-observability",
	"Reports" = "/reports",
	"Add Report" = "/add-report",
	"View Report" = "/view-report",
	"User Activity Logs" = "/user-activity-logs",
	"Monitoring" = "/monitoring",
	"Insilico" = "/personas",
	"Manage Keys " = "/manage-api-keys",
}

export enum ModuleTypes {
	"Studies" = "Studies",
	"DeepDive" = "Deep Dive",
	"Dashboard" = "Dashboard",
	"Insights" = "Insights",
	"AskKural" = "Ask Kural",
	"ManageStudies" = "Manage Studies",
	"ManageApiKeys" = "Manage Api Keys",
	"AddStudy" = "Add Study",
	"Reports" = "reports",
	"Taxonomy" = "Taxonomy",
	"Segments" = "Segments",
	"ManageSegments" = "Manage Segments",
	"Notes" = "Notes",
	"WebBoards" = "Web-Boards",
}

export enum ActionTypes {
	"ACCESS_UPDATED" = "Access Updated",
	"STARRED_UPDATED" = "Starred",
	"STUDIES_SEARCHED" = "Studies Searched",
	"STUDIES_DELETED" = "Studies Deleted",
	"STUDIES_CREATED" = "Studies Created",
	"FILE_UPLOAD" = "File Upload",
	"FILE_DOWNLOAD" = "File Download",
	"BULK_DOWNLOAD" = "Bulk Download",
	"FILE_DELETION" = "File Delete",
	"REFRESH_INSIGHTS" = "Refresh Insights",
	"EDIT_DG" = "Edit Discussion Guide",
	"VIEW_DG" = "View Discussion Guide",
	"EDIT_TRANSCRIPT" = "Edit Transcript",
	"VIEW_TRANSCRIPT" = "View Transcript",
	"AUTO_GENERATE_DG" = "Auto Generate Discussion Guide",
	"VIEW_NOTES" = "View Notes",
	"GENERATE_INSIGHTS" = "Generate Insights",
	"VIEW_REPORT" = "View Report",
	"PPT_EXPORT" = "PPT Export",
	"FILTER_CHARTS" = "Filter Charts",
	"COMPARE_CHARTS" = "Compare Charts",
	"DROPDOWN_SELECTION" = "Dropdown Selection",
	"SEARCH_CHARTS" = "Search Charts",
	"GENERATE_SUMMARY" = "Generate Summary",
	"EDIT_INSIGHTS_QUESTION" = "Edit Insight Tag",
	"VIEW_REFERENCES" = "View References",
	"TOTAL_QUERIES" = "Total Queries",
	"WIDGET" = "Widget",
	"COUNTS" = "Counts Widget",
	"QUOTES" = "Quotes Widget",
	"QUANT" = "Quant Widget",
	"TOTAL_COUNT" = "Total Chats",
	"REFERENCE" = "Reference",
	"CREATE_SEGMENT" = "Create Segment",
	"UPSERT_SEGMENT" = "Upsert Segment",
	"DELETE_SEGMENT" = "Delete Segment",
	"EDIT_SEGMENT" = "Edit Segment",
	"VIEW_SEGMENT" = "View Segment",
	"ASK_KURAL_RATING" = "Ask Kural Rating",
	"TOTAL_FOLLOW_UP" = "Total Follow-Up",
	"INSIGHTS_VIEWED" = "Insights Viewed",
	"REFLECTIVE_QUOTES_DRAWER_VIEWED" = "Reflective Quotes Drawer Viewed",
	"REFLECTIVE_COUNTS_DRAWER_VIEWED" = "Reflective Counts Drawer Viewed",
	"REFLECTIVE_TOTAL_CHATS" = "Reflective - Total Chats",
	"REFLECTIVE_TOTAL_QUERIES" = "Reflective - Total Queries",
	"ASK_KURAL_REFLECTIVE" = "Ask Kural - Reflective Mode",
	"ASK_KURAL_REFLECTIVE_MODE_FEEDBACK" = "Ask Kural - Reflective Mode Feedback",
}

export enum ModuleMap {
	"Notes" = "Research Notes",
	"WebBoards" = "Web Boards",
}
export enum FeatureList {
	ReflectiveMode = "reflective_mode",
}

export enum CollabCardRenderingFromType {
	ManageStudies = "Manage Studies",
	AddStudy = "Add Study",
	HomePage = "Home Page",
}

export enum SupportedLanguageType {
	English = "en",
	Hindi = "hi",
	Chinese = "zh",
	Japanese = "ja",
	Mandarin = "zh-CN",
}

export interface IUploadNotesFilesProps {
	isSaveDisabled: boolean;
	setIsSaveDisabled: (value: boolean) => void;
	editMode?: boolean;
	editModeDetails?: {
		file_id: string;
		file_name: string;
		note_id: string;
		study_id: string;
		dateRange: [string, string];
		dateFormat: string;
		column_mapping: any;
		web_board_keywords?: string;
	};
	handleEditNotes?: () => void;
	handleClose?: () => void;
	handleViewNotes?: () => void;
	getStudyDetailData?: () => void;
	setEditModeDetails?: (value: any) => void;
	setIsDataProcessed?: (value: boolean) => void;
	setIsFileFieldsTouched?: (value: boolean) => void;
	isDataProcessed?: boolean;
	notesFiles?: any[];
	isFileFieldsTouched?: boolean;
	newFileUploaded?: boolean;
	setNewFileUploaded?: (value: boolean) => void;
}

export interface ISelectedStudy {
	study_id: string | null;
	study_name: string | null;
	study_tags?: string[] | null;
	study_collaborators?: ICollaboratorData[] | null;
	insights_id?: string | null;
	access_type: UserAccessTypeString;
	created_by?: IAuthorData | null;
	study_type?: storyType | null;
	insights_available?: boolean | null;
	is_date_mapped?: boolean | null;
	quant_tabs?: ITab[] | null;
	study_language?: {
		name?: string;
		code?: string;
	};
	last_updated_at?: string;
	refresh_insights_id?: string; //quant insights id of a study
}

export interface IAddStudyData {
	study_id?: string;
	study_name: string;
	geography_id?: string;
	start_date?: string;
	end_date?: string;
	description: string;
	project_code?: string;
	custom_tags?: string[];
	study_type_id: string;
	template_id?: string;
	context?: string;
	study_language?: {
		name?: string;
		code?: string;
	};
	taxonomy_id?: string;
	folder_id?: string;
	process_video?: boolean;
}

export interface INotesPreviewRowData {
	column_name: string;
	values: string[];
}

export interface INotesPreviewData {
	rows: INotesPreviewRowData[];
}

export interface IUserData {
	full_name: string;
	user_id: string;
	email: string;
}

export interface IVersionHistory {
	created_dt?: string;
	created_by?: IUserData;
	modified_dt?: string;
	modified_by?: IUserData;
}

export interface ICollaboratorData {
	collaborator_id: string;
	collaborator_email?: string;
	collaborator_name: string;
	user_access_type?: UserAccessTypeString;
	is_owner?: boolean;
	is_active?: boolean;
}

export interface IStudyData {
	study_id: string;
	study_name: string;
	study_type: storyType;
	description: string;
	collaborators: ICollaboratorData[];
	custom_tags: string[] | null;
	start_dt?: string;
	end_dt?: string;
	geography?: string;
	user_access_type?: UserAccessTypeString;
	is_star?: boolean;
	folder?: {
		folder_id: string;
		folder_name: string;
		folder_description: string;
		folder_tags: string[];
	};
	count_of_file?: number;
	version_history?: IVersionHistory;
	insights_available?: boolean;
	active_insights_id?: string;
	refresh_insights_id?: string; //this is the actual insights id
	is_date_mapped?: boolean | null;
	quant_tabs: ITab[];
	study_language?: {
		name?: string;
		code?: string;
	};
}

export interface IDropdownItem {
	label: string | studyTypeString;
	value: string;
}

export interface IDropdownMaster {
	study_type: IDropdownItem[];
	geography: IDropdownItem[];
	custom_tags: IDropdownItem[];
}

export interface ICollabCardProps {
	payload: IStudyData;
	handleDeleteStudy?: (study_id: string) => void;
	activeStudyId?: string;
	isSelected: boolean;
	onSelect?: () => void;
	onEditStudy?: () => void;
	renderedFrom: CollabCardRenderingFromType;
	showButtonHighlight?: boolean;
}

export interface IFileTableProps {
	data: Record<string, any>[];
	handleDeleteFile?: (fileId: string, fileType: string, secFileId: string) => void;
	t: any;
}

export interface ICustomFormProps {
	title?: string;
	form: any;
	onFinish?: (values: any) => void;
	formConfig: Array<any>;
}

export interface ICustModalProps {
	profile?: string;
	isModalOpen: boolean;
	handleOk: () => void;
	handleCancel: () => void;
	studyData?: IAddStudyData;
	payload?: ICollaboratorData[];
	studyId?: string;
}

export interface IResponse<T = any> {
	data?: T;
	error?: any;
	message?: string | null;
	is_error?: boolean;
	error_type?: string;
	quant_tabs?: any;
}

/** Backend ResponseModel wrapper ({ data, error, message }) */
export interface IStandardApiResponse<T = unknown> {
	data: T | null;
	error: string | null;
	message?: string | null;
}

export interface IPaginatedResult<T> {
	data: T[];
	total: number;
	page: number;
	page_size: number;
	total_pages?: number;
}

export interface IDownloadUrlData {
	url: string;
	file_type?: string;
	extension?: string;
	filename?: string;
}

/** Inner payload from GET files/ (nested under ResponseModel.data) */
export interface IFilesDetailsPayload {
	data: unknown[];
	data_status: unknown[];
	insights_status?: Record<string, unknown>;
	quant_tabs?: unknown[];
}

export interface IAdminResponse<T = any> {
	data?: T;
	error?: any;
	message?: string | null;
	is_error?: boolean;
	error_type?: string;
	[key: string]: any;
}

export interface IFilesUploadProps {
	studyType: string;
	studyId: string;
}

export interface ITableProps {
	id: string;
	uploaded_files: string;
	uploaded_by: string;
	uploaded_date: string;
	status: string;
	type: string;
	status_log: statusLogString;
	file_id: string;
	[key: string]: string;
}

export interface IDeleteFilePayload {
	study_id: string;
	document_type: string;
	document_id?: string;
	file_id?: string; // optional — backend ignores file_id for metadata type
}

export interface IFileDownloadPayload {
	file_name?: string;
	file_type: string;
	study_id: string;
	file_id?: string;
	tr_id?: string;
	doc_download_format?: string;
	study_type_name?: string;
	adm_source?: string;
	config_source?: string;
	iteration_id?: string;
}

export interface IReportAvailable {
	home: boolean;
	manage_study: boolean;
	add_study: boolean;
	ask_kural: boolean;
	[key: string]: boolean;
}

export interface IConfig {
	is_report_available: IReportAvailable;
}

export interface IProfileLanguageMapping {
	profile_name: string;
	profile_id: string;
	languages: ILanguage[];
}

export interface ILanguage {
	name: string;
	code: string;
	is_primary?: boolean;
}

export interface IMetaDetails {
	config: IConfig;
	id: string;
	fullName: string;
	user_email: string;
	isAdmin?: boolean;
	roles?: string[];
	profiles?: string[];
	current_profile_id: string;
	current_primary_language: string;
	current_secondary_language: string[];
	languages?: ILanguage[];
	profile_language_mapping: IProfileLanguageMapping[];
	feature_mapping?: any[];
	is_delete_executor?: boolean;
	// True when the user's role(s) legitimately need no profile assigned
	// (admin family + developer → backend PROFILE_EXEMPT_ROLES). Lets the UI
	// skip the "no profiles assigned" screen for these roles.
	allows_no_profile?: boolean;
	// Time-limited access fields (from masters/metadata).
	// access_expires_at: null → never expires (superadmin).
	// show_expiry_banner: true within T-14 of expiry; copy escalates by days_until_expiry.
	access_expires_at?: string | null;
	days_until_expiry?: number | null;
	show_expiry_banner?: boolean;
	is_superadmin?: boolean;
}

export interface InsightDetails {
	study_id: string;
	[key: string]: any;
}

export interface DeepDiveData {
	collaborators: any[];
	insight_details: InsightDetails;
	study_name: string;
	study_tags: any[];
	user_access_type: string;
	selectedQuesId: number | null;
	blurOnOpen: boolean;
}

export interface IConfirmationObj {
	status: string;
	editType?: string;
	visible: boolean;
	name?: string;
	redirectFrom: string;
}

export enum ReportAvailabilityKey {
	HOME = "home",
	MANAGE_STUDY = "manage_study",
	ADD_STUDY = "add_study",
	ASK_KURAL = "ask_kural",
}

export enum CognitiveAvailabilityKey {
	HOME = "home",
	MANAGE_STUDY = "manage_study",
	ADD_STUDY = "add_study",
	ASK_KURAL = "ask_kural",
}

export enum AddType {
	ADD_STUDY = "Add Study",
	MANAGE_STUDY = "Manage Study",
}

export interface IReportPreviewResponse {
	url: string;
}

export interface ICollabTableProps {
	activeStudyId?: string;
	selectedCardIndex: number | null;
	onSelect: (index: number) => void;
	onEditStudy: (study: IStudyData) => void;
	renderedFrom: CollabCardRenderingFromType;
	loading?: boolean;
	folders: IFolderData[];
	allFolders?: IFolderData[];
	studies: IStudyData[];
	onFolderNavigate?: (folder: IFolderData | null) => void;
	setBackHandler?: (handler: () => void) => void;
	onEditFolder?: (folder: IFolderData) => void;
	onRefreshStudies?: (targetFolderId?: string | null) => void;
	allUntrackedStudies?: IStudyData[];
	setFolderClickHandler?: (handler: (folder: IFolderData) => void) => void;
	currentFolder?: IFolderData | null;
	fetchAllStudies?: (selectedStudyPageTab?: string) => void;
	selectedStudyPageTab?: string;
	onHasSelectedStudiesChange?: (hasSelection: boolean) => void;
}

export interface ICompletionData {
	upload_data?: {
		upload_id: string;
		parts: IPart[];
	};
	study_type_name: string;
	file_id: string;
	study_id: string;
	file_type: string;
	file_name: string;
	total_chunks: number;
	is_error: boolean;
	version?: number;
}

interface IPart {
	PartNumber: number;
	ETag: string;
}

interface IPresignedUrlsInfo {
	part_number: number;
	url: string;
}

export interface IPresignedUrlsResponse {
	file_id: string;
	upload_id: string;
	file_name: string;
	presigned_urls_info: IPresignedUrlsInfo[];
}

export interface IAuthorData {
	email: string;
	full_name: string;
	user_id: string;
	_id?: string;
	user_access_type?: UserAccessTypeString;
}

export interface ICollaboratorsTableProps {
	authorUser: IAuthorData;
	fullAccessUsers: ICollaboratorData[];
	isModalOpen: boolean;
	handleOk: () => void;
	handleCancel: () => void;
	studyId?: string;
	studyName?: string;
	renderedFrom?: ModuleType;
	reportIterationId?: string;
	reportStatus?: string;
	folderId?: string;
	onRefreshStudies?: (folderId: string) => void;
	projectId?: string;
	projectName?: string;
}

export interface IFilterStudiesProps {
	studiesData: IStudyData[];
	searchText: string;
	selectedCollaborators: { collaborator: string }[];
	selectedTag: string;
}

export interface IIterationForm {
	studyId?: string;
	studyType?: string;
	iterationNextDisabled?: boolean;
	setIterationNextDisabled?: (value: boolean) => void;
	form: any;
	selectedIterationId: string | null;
	setSelectedIterationId: (value: string | null) => void;
	onFormChange: (value: any, value2: any) => void;
	isFormChanged: boolean;
	showIterationForm: boolean;
	setShowIterationForm: (value: boolean) => void;
	isEditMode: boolean;
	setIsEditMode: (value: boolean) => void;
}

export interface IIterationPayload {
	iteration_id?: string;
	study_id: string;
	iteration_name: string;
	iteration_description: string;
	wave?: string;
	field_work_start: string;
	field_work_end: string;
	filesCount?: number;
	iteration_custom_tags?: string[];
	status?: boolean;
	version_history?: IVersionHistory;
	iteration_context?: string;
}

export interface IConfigFileProps {
	studyId?: string;
	studyType?: string;
	isOpen?: boolean;
	onClose?: () => void;
	onFileDelete?: () => void;
	insightsButtonStatus?: any;
}

interface ISection {
	sect_name: string;
	q_count: number;
	face_q_id: string;
	face_q_index: number;
}

export interface ITab {
	tab_name: string;
	sections: ISection[];
}

export interface IFolderData {
	folder_id: string;
	folder_name: string;
	updated_at?: string;
	studies?: IStudyData[];
	folder_description?: string;
	folder_tags?: string[];
	study_count?: number;
	can_delete?: boolean; // Calculated client-side or from API
	can_edit?: boolean; // Optional: if needed
}

export interface ICreateFolderFormProps {
	form: any;
	existingFolders?: IFolderData[];
	onTagsChange?: (tags: string[]) => void;
	initialValues?: {
		folder_name?: string;
		folder_description?: string;
		folder_tags?: string[];
	};
	disabled?: boolean;
	className?: string;
}

export interface IFolderModalProps {
	isOpen: boolean;
	folders: IFolderData[];
	selectedStudiesCount: number;
	currentFolderId?: string | null;
	onMove: (folderId: string | null) => void;
	onCancel: () => void;
}

export interface IFolderData {
	folder_id: string;
	folder_name: string;
	updated_at?: string;
	studies?: IStudyData[];
	folder_description?: string;
	folder_tags?: string[];
	version_history?: IVersionHistory;
	delete_folder: boolean;
	delete_folder_reason: string;
	delete_folder_with_studies: boolean;
	delete_folder_with_studies_reason: string;
}

export interface ICreateFolderFormProps {
	form: any;
	existingFolders?: IFolderData[];
	onTagsChange?: (tags: string[]) => void;
	initialValues?: {
		folder_name?: string;
		folder_description?: string;
		folder_tags?: string[];
	};
	disabled?: boolean;
	className?: string;
}

export interface IFolderModalProps {
	isOpen: boolean;
	folders: IFolderData[];
	selectedStudiesCount: number;
	currentFolderId?: string | null;
	onMove: (folderId: string | null) => void;
	onCancel: () => void;
}

export interface IFolderDropdownProps {
	form: FormInstance;
	options: IFolderData[];
	disabled: boolean;
	initialValue?: string | null;
}

export interface TagOption {
	label: string;
	value: string;
}
export interface ITrackingEvent {
	module: string;
	feature?: string;
	sub_feature?: string;
	session_id?: string;
	type?: string;
	description?: string;
	event_type: string;
	start_time?: string;
	end_time?: string | null;
	rating?: number | null;
	metadata?: {
		study_id?: string;
		study_name?: string;
		file_name?: string;
		file_id?: string;
		file_type?: string;
		ques_id?: string;
	};
}

export interface IActionTrackingData {
	study_id?: string;
	study_name?: string;
	study_type?: string;
	project_id?: string;
	project_name?: string;
	stimuli_id?: string;
	stimuli_type?: string;
	persona_id?: string;
	run_id?: string;
	tab?: string;
	view?: string;
	format?: string;
	item_index?: number;
	section_count?: number;
	total_tests?: number;
	offset?: number;
	profile_signature?: string;
	segment_type?: string;
	segment_value?: string;
	category?: string;
	sort?: string;
	action_name?: string;
	file_name?: string;
	file_id?: string;
	file_type?: string;
	ques_id?: string;
	type?: string;
	feature?: boolean;
	subAction?: string;
	module?: string;
	rating?: boolean;
	count?: number;
	featureName?: string;
	showReflectiveFeedbackModal?: boolean;
}

export enum FeatureKeysType {
	Segment = "segment-enabled",
	TemplateUpload = "template-upload",
	TemplateUploadVersion2 = "deck-template-qnt2",
	FolderUpsert = "folder-upsert",
	PptExport = "ppt-export",
	KnowledgeChunks = "knowledge-chunks",
	AskKural = "ask-kural",
	WidgetDropdown = "widget-dropdown",
	CountsWidget = "counts-widget",
	QuotesWidget = "quotes-widget",
	Storyboard = "storyboard",
	TaxonomyUpsert = "taxonomy-upsert",
	MultiLingualSupport = "multi-lingual-support",
	CacheQuantDf = "cache_quant_df",
	ClientOnlyCollaborators = "client_only_collaborators",
	QuantCsvDownload = "quant-csv-download",
	SimulationMessageTesting = "simulation_message_testing",
	StudyUpsert = "study-upsert",
	Notes = "notes",
	MyFeed = "my-feed",
	ProjectCodeReq = "project-code-req",
	Reports = "reports",
	Pxb = "pxb",
	Quant = "quant",
	WebBoards = "web_boards",
	QuantSummary = "quant-summary",
	MarketResearch = "market_research",
	Cognitive = "cognitive",
	PagePosition = "page-position",
	RawReconstruct = "raw-reconstruct",
	UserActivityMonitoring = "user-activity-monitoring",
	EnableFolder = "enable-folders",
	AgenticAskKural = "agentic-ask-kural",
	UserGuide = "user-guide",
	ReflectiveModeCampaign = "reflective-mode-campaign",
	ReflectiveModeFeedback = "reflective-mode-feedback",
	ProfileContext = "manage-profile-context",
	Personas = "personas",
	ServiceAccount = "manage-service-account",
	AdminTranscriptExport = "admin-transcript-export",
	AppLicenseExpiry = "app-license-expiry",
	EmailAlert = "manage-email-alerts",
	ExportAuditLogs = "export-audit-logs",
	ExportAskKuralLogs = "export-ask-kural-logs",
	AutoGenerateADM = "helix-adm",
	SecondaryDataEnabled = "secondary_data_enabled",
	NpiAccessCheck = "npi_access_check",
	AskKuralPptGeneration = "ask-kural-ppt-generation",
	DigitalTwin = "digital-twin",
	NPIAccessCheck = "npi_access_check",
	Copyright = "copyright",
	AudioVideo = "audio-video",
	AvNarrations = "av-narrations",
	CustomSegments = "custom-segments",
	EditMetadata = "edit-metadata",
	EditMetadataVirtualRows = "edit-metadata-virtual-rows",
	AskKuralGovernance = "ask_kural_governance",
	AskKuralChatExportPdf = "ask-kural-chat-export-pdf",
}

export type SortBy = "name" | "updated_at";
export type SortOrder = "asc" | "desc";

export interface SortState {
	sort_by: SortBy;
	sort_order: SortOrder;
}

export interface IStudiesCount {
	total_studies_count: number;
	studies_with_edit_access: number;
}

export interface IFolderAction {
	action_id: string;
	action_label: string;
	is_enabled: boolean;
	message: string;
	message_type: number;
}

export interface IFolderDeleteResponse {
	success: boolean;
	message: string;
	data: {
		studies_count: IStudiesCount;
		folder_actions: IFolderAction[];
	};
}

export interface IDeleteOption {
	button_text: string;
	button_value: string;
	button_description: string;
	button_status: boolean;
}

export interface IFolderDeleteModalProps {
	isOpen: boolean;
	folderName: string;
	deleteOptions: IDeleteOption[];
	loading: boolean;
	onDelete: (buttonValue: string) => void;
	onCancel: () => void;
}

export interface IFeatureList {
	feature_name: string;
	show_notification: boolean;
	show_congrats?: boolean;
	approved?: boolean;
}

// ── Personas module types ──────────────────────────────────────────────────

/** Metadata keyed by studyId → transcriptPath → key → value (user-added tags) */
export type TranscriptMetadataStore = Record<string, Record<string, Record<string, string>>>;

export interface IPersonaAppearance {
	version?: string;
	paletteIndex?: number;
	avatarSeed?: string;
	avatarAssetId?: string;
	avatarStyle?: string;
	voiceId?: string;
}

export interface IPersonaAvatarAsset {
	id: string;
	name?: string;
	description?: string;
	thumbnailUrl: string;
	cdnUrl?: string | null;
	approved?: boolean;
	tags?: string[];
	customFields?: Record<string, string>;
	provider?: "brandfolder" | string;
}

export interface IPersona {
	id: string;
	name: string;
	definition: string;
	appearance?: IPersonaAppearance;
	systemPrompt?: string;
	attachedStudyIds?: string[];
	attachedTranscripts?: Record<string, string[] | undefined>;
	transcriptMetadata?: TranscriptMetadataStore;
}

export interface IInspiration {
	study_id: string;
	study_title: string;
	score: number;
	filepath: string;
}

export interface IGroundingSource {
	id: string;
	source_type: "transcript" | "report" | string;
	title: string;
	quote: string;
	claim?: string;
	evidence_type?: string;
	confidence?: number;
	filepath?: string;
	study_id?: string;
	chunk_id?: string;
}

export interface IMessage {
	id: string;
	role: "user" | "assistant";
	content: string;
	groundingMarkup?: string;
	createdAt: string;
	inspirations?: IInspiration[];
	groundingSources?: IGroundingSource[];
	references?: string[];
}

export interface IChatAttachedFile {
	fileId: string;
	filename: string;
	fileType: "xlsx" | "xls" | "csv" | "pptx";
	uploadedAt: string;
}

export interface IChat {
	id: string;
	category: "segment" | "setting";
	personaId: string;
	title: string;
	saved: boolean;
	createdAt: string;
	updatedAt: string;
	attachedFile?: IChatAttachedFile | null;
	messages: IMessage[];
}

export interface ICategory {
	personas: IPersona[];
}

export interface IPersonaMarketContextStatus {
	status?: string;
	hasActivePack?: boolean;
	activeItemCount?: number;
	hasEvidence?: boolean;
	isStale?: boolean;
	refreshStarted?: boolean;
	message?: string | null;
}

export interface IPersonaProject {
	id: string;
	name: string;
	description: string;
	created_by?: string;
	profile_id?: string;
	is_owner?: boolean;
	project_collaborators?: ICollaboratorData[];
	user_access_type?: UserAccessTypeString;
	persona_count?: number;
	study_count?: number;
	createdAt: string;
	updatedAt: string;
	categories: {
		segment: ICategory;
		setting: ICategory;
	};
	chats: IChat[];
	marketContextStatus?: IPersonaMarketContextStatus | null;
}

// ── Digital Twin module types ────────────────────────────────────────────────

export interface IDTUploadedFile {
	file_name: string;
	s3_key: string;
	uploaded_at: string;
	file_count: number;
	dt_persona_count?: number;
}

export interface IDTProject {
	id: string;
	name: string;
	description: string;
	therapy_area: string;
	disease_name: string;
	indication: string;
	created_by: string;
	profile_id?: string;
	is_owner?: boolean;
	uploaded_file?: IDTUploadedFile;
	project_collaborators?: ICollaboratorData[];
	user_access_type?: UserAccessTypeString;
	createdAt: string;
	updatedAt: string;
}
